<i18n>
{
  "en": {
    "discount": "Discount {discount}% off"
  },
  "zh-tw": {
    "discount": "優惠折扣 {discount}%"
  }
}
</i18n>

<template>
  <div>
    <!-- 選中的優惠折扣不用顯示這一行 -->
    <p v-if="showTitle" style="margin: 0px">{{ $t(`discount`, { discount }) }}</p>
    <span class="item-line-through">${{ totalPrice }}</span>
    <i class="material-icons md-only" style="font-size: 16px; margin-left: .3rem">arrow_forward</i>
    <span style="margin-left: .5rem;">${{ discountPrice }}</span>
  </div>
</template>

<script>
export default {
  computed: {
    discountPrice () {
      const discountAmount = Math.round(this.totalPrice * this.discount / 100)
      return this.totalPrice - discountAmount
    }
  },
  props: {
    totalPrice: {
      type: Number
    },
    discount: {
      type: Number
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style>
  .item-line-through {
    text-decoration: line-through #888888 double;
  }
</style>
